import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row} from "react-bootstrap";
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const AssetCollAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [assetCollAttrs, setAssetCollAttrs] = useState({
    id: '',
    name: '',
    description: '',
    almSuspStatus: 'NO'
  });

  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setAssetCollAttrs({ ...assetCollAttrs, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!assetCollAttrs.name || assetCollAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (assetCollAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");

    } else if (!assetCollAttrs.description || assetCollAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (assetCollAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");

    } else {
      validateNames();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateNames() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("asset-colls?name=" + assetCollAttrs.name);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // AssetColl code is taken
          setErrMsg(t("I18N_ERR_Dup_name"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    createNewAssetColl();
  }

  const createNewAssetColl = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(assetCollAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.post("asset-colls", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Asset_Coll")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_AssetColl_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <Row className={classes.admin_pages__field_label}>
            <Col md={3}>{t("I18N_Name")}: *</Col>
            <Col md={3}>{t("I18N_Description")}: *</Col>
            <Col md={3}></Col>
            <Col md={3}></Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col md={3}>
              <input className={classes.admin_pages__field_editable} name="name" value={assetCollAttrs.name}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col md={3}>
              <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={assetCollAttrs.description}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col md={3}></Col>
            <Col md={3}></Col>
          </Row>

          <hr className="solid" style={{ marginTop: '30px' }}></hr>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
            <span>{t("I18N_Req_fields")}</span>
          </Row>

          <Row>
            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleCancel}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleSubmit}>
                {t("I18N_Submit")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {errMsg}
              </span>
            </div>
          </Row>
        </Container>

      </Card>
    </>
  );
}
 
export default AssetCollAdminNewView;
